import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Home, 
  Heart, 
  ClipboardList, 
  ShoppingCart, 
  User, 
  LogOut, 
  Package, 
  Users, 
  Info, 
  Mail, 
  Smartphone,
  X 
} from 'lucide-react';
// import { useAppVersion } from '../hooks/useAppVersion';

function MobileDrawer({ open, onClose, user, cartCount, onLogout }) {
  // const { latestVersion, downloadApp } = useAppVersion();

  return (
    <div className={`fixed inset-0 z-50 ${open ? '' : 'pointer-events-none'}`} aria-hidden={!open}>
      {/* Backdrop */}
      <div
        className={`absolute inset-0 bg-black/30 transition-opacity ${open ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
      />
      {/* Panel */}
      <div
        className={`absolute left-0 top-0 h-full w-64 bg-white shadow-xl transform transition-transform ${open ? 'translate-x-0' : '-translate-x-full'}`}
      >
        <div className="p-4 border-b border-gray-200 flex items-center justify-between">
          <span className="font-semibold">Menu</span>
          <button onClick={onClose} className="p-1 rounded-lg hover:bg-gray-100" aria-label="Close Menu">
            <X className="w-5 h-5" />
          </button>
        </div>
        <nav className="p-4 space-y-2">
          
          <Link to={user ? '/dashboard' : '/'} onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
            <Home className="w-5 h-5 text-gray-500" />
            <span>Home</span>
          </Link>
          <Link to="/wishlist" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
            <Heart className="w-5 h-5 text-gray-500" />
            <span>Wishlist</span>
          </Link>
          <Link to="/orders" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
            <ClipboardList className="w-5 h-5 text-gray-500" />
            <span>My Orders</span>
          </Link>
          <Link to="/checkout" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
            <ShoppingCart className="w-5 h-5 text-gray-500" />
            <span>Cart {cartCount > 0 ? `(${cartCount})` : ''}</span>
          </Link>
          
          {user ? (
            <>
              <Link to="/profile" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
                <User className="w-5 h-5 text-gray-500" />
                <span>Profile</span>
              </Link>
              <button
                onClick={() => { onLogout && onLogout(); onClose(); }}
                className="w-full text-left flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100 text-red-600"
              >
                <LogOut className="w-5 h-5" />
                <span>Logout</span>
              </button>
            </>
          ) : (
            <Link to="/login" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
              <User className="w-5 h-5 text-gray-500" />
              <span>Login</span>
            </Link>
          )}
          {user?.role === 'admin' && (
            <>
              <div className="pt-2 text-xs text-gray-500">Admin</div>
              <Link to="/admin/orders" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
                <ClipboardList className="w-5 h-5 text-gray-500" />
                <span>Manage Orders</span>
              </Link>
              <Link to="/admin/products" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
                <Package className="w-5 h-5 text-gray-500" />
                <span>Products</span>
              </Link>
              <Link to="/admin/users" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
                <Users className="w-5 h-5 text-gray-500" />
                <span>Manage Users</span>
              </Link>
              <Link to="/admin/app-updates" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
                <Smartphone className="w-5 h-5 text-gray-500" />
                <span>App Updates</span>
              </Link>
            </>
          )}

          {/* Divider */}
          <div className="border-t border-gray-200 my-2"></div>
          
          {/* About & Contact Links */}
          <Link to="/about" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
            <Info className="w-5 h-5 text-gray-500" />
            <span>About Us</span>
          </Link>
          <Link to="/contact" onClick={onClose} className="flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100">
            <Mail className="w-5 h-5 text-gray-500" />
            <span>Contact Us</span>
          </Link>
          
          {/* Download App Link */}
          {/* {latestVersion && (
            <button
              onClick={() => {
                downloadApp();
                onClose();
              }}
              className="w-full text-left flex items-center gap-2 px-3 py-2 rounded hover:bg-gray-100"
            >
              <FontAwesomeIcon icon={faMobileAlt} className="w-5 h-5 text-gray-500" />
              <span>Download App</span>
              {latestVersion.version && (
                <span className="ml-auto text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-semibold">
                  v{latestVersion.version}
                </span>
              )}
            </button>
          )} */}
        </nav>
      </div>
    </div>
  );
}

export default MobileDrawer;


